export default __webpack_public_path__ + "static/media/faq-bg.4a514b3f.jpg";